import React, { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from 'hooks/useStores';
import setUrlParam from 'utils/setUrlParam';

import Checkbox from 'ati-ui-react/components/Checkbox';

const OnlyNew: FC = observer(() => {
  const {
    findTrucksStore: {
      fields: { only_new },
      updateCheckBox,
    },
  } = useStores();

  return (
    <Checkbox
      label="Только&nbsp;новые"
      onChange={() => {
        updateCheckBox({ field: 'only_new', value: !only_new });
        setUrlParam({ field: 'only_new', value: !only_new });
      }}
      checked={only_new}
      size="small"
    />
  );
});

export default OnlyNew;
